import { render, staticRenderFns } from "./ReportFinances.vue?vue&type=template&id=c8ce481e&"
import script from "./ReportFinances.vue?vue&type=script&lang=ts&"
export * from "./ReportFinances.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports